import React from "react";
import PropTypes from "prop-types";

import ArrowBackIcon from "@mui/icons-material/ArrowBackIos";

import styles from "./Header.module.scss";

const Header = ({ handleBack, currentJob }) => {
  return (
    <>
      <div>
        <a href="#" onClick={handleBack} className={styles["back-button"]}>
          <ArrowBackIcon style={{ maxHeight: 15 }} />
          <span>Back</span>
        </a>

        <h1 className={styles.title}>
          {`${currentJob.clientCorporation && currentJob.clientCorporation.name} - ${
            currentJob.publicName
          }`}
        </h1>
      </div>
    </>
  );
};

Header.propTypes = {
  handleBack: PropTypes.func,
  currentJob: PropTypes.any
};

export { Header };
